import { client } from '@/services/client/client';
import type { StandardizedApiError } from '@/services/client/types';
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useHandleQueryErrors } from '../hooks/useHandleQueryErrors';

export function useApiClient() {
  const { handleErrors } = useHandleQueryErrors();

  const mutationCache = useMemo(
    () =>
      new MutationCache({
        onError: (err) => {
          handleErrors(err as StandardizedApiError);
        },
      }),
    [handleErrors],
  );

  const queryCache = useMemo(
    () =>
      new QueryCache({
        onError: (err) => {
          handleErrors(err as StandardizedApiError);
        },
      }),
    [handleErrors],
  );

  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
          },
        },
        mutationCache,
        queryCache,
      }),
    [mutationCache, queryCache],
  );

  return {
    client,
    queryClient,
  };
}
